module.exports = [
  "backend.config",
  "DS",
  function(backend, DS) {
    window.DS = DS;
    var currentWeek;

    var projects = DS.defineResource({
      name: "timesheets.projects",
      endpoint: "unrestricted-projects",
      idAttribute: "weekNumber",
      deserialize: function deserialize(resourceConfig, data) {
        return data
          ? "data" in data
            ? {
                weekNumber: data.config.attrs.weekNumber,
                projects: data.data,
                accessTime: moment().format("YYYYMMDD")
              }
            : data
          : data;
      },
      getFallbackRefresh: function(config, data) {
        currentWeek = currentWeek || parseInt(moment().format("YYYYWW"));
        var accessTime = parseInt(data.accessTime || 0);
        return accessTime < currentWeek - 1;
      }
    });
    projects.find.before(function(id, opts) {
      opts = opts || {};
      opts.endpoint =
        "timesheets/" +
        backend.enterprise.code +
        "/" +
        backend.userdata.email +
        "/unrestricted-projects";
      return [id, opts];
    });

    return {
      getUnrestrictedProjects: function(weekNumber) {
        if (!weekNumber) {
          weekNumber = moment().format("YYYYWW");
        }
        var cached = projects.get(weekNumber);
        if (cached) {
          return DS.utils.Promise.when(cached);
        }
        return projects.find(weekNumber, {
          attrs: {
            weekNumber: weekNumber
          }
        });
      }
    };
  }
];



// WEBPACK FOOTER //
// ./src/api/js-data/api/projects.js